var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdhocMeal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 3.33333H5.83333C4.44928 3.33333 3.75726 3.33333 3.28596 3.71053C2.91667 4.00543 2.91667 4.55362 2.91667 5.65V15.5C2.91667 16.5964 2.91667 17.1446 3.28596 17.4395C3.75726 17.8167 4.44928 17.8167 5.83333 17.8167H14.1667C15.5507 17.8167 16.2427 17.8167 16.714 17.4395C17.0833 17.1446 17.0833 16.5964 17.0833 15.5V5.65C17.0833 4.55362 17.0833 4.00543 16.714 3.71053C16.2427 3.33333 15.5507 3.33333 14.1667 3.33333H13.3333",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 3.33333C6.66667 2.64298 7.22631 2.08333 7.91667 2.08333H12.0833C12.7737 2.08333 13.3333 2.64298 13.3333 3.33333C13.3333 4.02369 12.7737 4.58333 12.0833 4.58333H7.91667C7.22631 4.58333 6.66667 4.02369 6.66667 3.33333Z",
    stroke: "white",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 9.16667H13.75",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 12.5H11.6667",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdhocMeal);
export default __webpack_public_path__ + "static/media/adhoc_meal.166a922e0cf856e8933cf5a3c6247631.svg";
export { ForwardRef as ReactComponent };